/** @jsx isolateComponent */
import { useState } from 'react';
import { isolateComponent } from '@zapier/style-encapsulation';
import { Button, Colors, Typography } from '@zapier/design-system';
import PositiveFeedback from '../PositiveFeedback';
const Styles = {
    inner: {
        alignItems: 'center',
        display: 'grid',
        gridGap: 20,
        gridTemplateColumns: '1fr min-content min-content',
        justifyItems: 'end',
    },
    innerSmall: {
        gridTemplateColumns: '1fr',
        justifyItems: 'start',
    },
    resolvedButtonsText: Object.assign(Object.assign({}, Typography.paragraph3Bold), { color: Colors.gray }),
    root: {
        display: 'grid',
        gridGap: 60,
    },
};
const RebrandStyles = {
    resolvedButtonsText: Object.assign(Object.assign({}, Typography.paragraph3Semibold), { color: Colors.neutral800 }),
};
/**
 * Displayed on all but the last stage of the `<HelpBlock>` component.
 */
const Feedback = ({ onGoToNextStep, onClickHelpCenterLink, onClickNoWhatsNext, size, }) => {
    const [didSolve, setDidSolve] = useState();
    const didProvideFeedback = typeof didSolve === 'boolean';
    const yesColor = didProvideFeedback ? 'primary-alt' : 'secondary';
    const onClickYes = () => {
        setDidSolve(true);
    };
    const onClickNo = () => {
        setDidSolve(false);
        onClickNoWhatsNext();
        onGoToNextStep();
    };
    return (isolateComponent("div", { css: Styles.root },
        isolateComponent("div", { css: [Styles.inner, size === 'small' && Styles.innerSmall] },
            isolateComponent("p", { css: RebrandStyles.resolvedButtonsText }, "Did this solve your issue?"),
            isolateComponent(Button, { color: yesColor, onClick: onClickYes }, "Yes, thank you"),
            isolateComponent(Button, { color: "primary", disabled: didProvideFeedback, onClick: onClickNo }, "No, what\u2019s next?")),
        didSolve && (isolateComponent(PositiveFeedback, { onClickHelpCenterLink: href => onClickHelpCenterLink(href), onGoToNextStep: onGoToNextStep }))));
};
export default Feedback;
